import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { style } from "./styles";
import { Grid, Button, MenuItem } from "@material-ui/core";
import Header from "../../../partials/header";
import InputFormat from "../../../partials/inputForm";
import TableFormat from "../../../partials/TableFormat";
import Loading from "../../loading";
import FilterList from "../../../partials/filterList";
import PriceFormat from "../../../partials/priceFormat";
import MultiLevelCategoryList from "../../productCategory/multiLevelCategoryList";

const headCells = [
  {
    key: "name",
    numeric: false,
    disablePadding: false,
    label: "product_title",
  },
  { key: "sku", numeric: false, disablePadding: false, label: "product_sku" },
  {
    key: "stock_quantity",
    numeric: false,
    disablePadding: false,
    label: "stock_quantity",
  },
  {
    key: "regular_price",
    numeric: false,
    disablePadding: false,
    label: "product_regular_price",
  },
  { key: "action", numeric: false, disablePadding: false, label: "" },
];
const enablebOption = [
  { label: "all", value: -1 },
  { label: "yes", value: "true" },
  { label: "no", value: "false" },
];
const discontinuedOption = [
  { label: "all", value: -1 },
  { label: "yes", value: "true" },
  { label: "no", value: "false" },
];
const on_saleOption = [
  { label: "all", value: -1 },
  { label: "yes", value: "true" },
  { label: "no", value: "false" },
];
const stock_statusOption = [
  { label: "all", value: -1 },
  { label: "product_out_of_stock", value: "out_of_stock" },
  { label: "product_available", value: "available" },
  { label: "product_backorder", value: "backorder" },
  { label: "product_preorder", value: "preorder" },
  { label: "product_discontinued", value: "discontinued" },
];
export class ProductMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: "",
      discontinued: "",
      on_sale: "",
      stock_tatus: "",
      enabled: "",
      listFilter: {
        discontinued: "",
        on_sale: "",
        stock_tatus: "",
        enabled: ""
      },
    };
  }
  async componentDidMount() {
    this.props.getProductCategory();
  }
  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let state = this.state;
    state[name] = value;
    this.setState({
      state,
    });
  };
  checkListFilter = () => {
    let { enabled, on_sale, stock_status, discontinued, listFilter } = this.state;
    listFilter["enabled"] = enablebOption.find(item => item.value === enabled);
    listFilter["enabled"] = listFilter["enabled"] ? listFilter["enabled"].label : "";

    listFilter["on_sale"] = on_saleOption.find(item => item.value === on_sale);
    listFilter["on_sale"] = listFilter["on_sale"] ? listFilter["on_sale"].label : "";

    listFilter["discontinued"] = discontinuedOption.find(item => item.value === discontinued);
    listFilter["discontinued"] = listFilter["discontinued"] ? listFilter["discontinued"].label : "";

    listFilter["stock_status"] = stock_statusOption.find(item => item.value === stock_status);
    listFilter["stock_status"] = listFilter["stock_status"] ? listFilter["stock_status"].label : "";

    this.setState({ listFilter })
  }
  getProduct = async (payload = {}) => {
    let { enabled, on_sale, stock_status, discontinued } = this.state;
    if (enabled !== -1) payload.enabled = enabled;
    if (on_sale !== -1) payload.on_sale = on_sale;
    if (stock_status !== -1) payload.stock_status = stock_status;
    if (discontinued !== -1) payload.discontinued = discontinued;
    this.loading.startLoading();
    await this.props.getProduct(payload);
    this.loading.stopLoading();
    this.checkListFilter()
  };
  deleteProduct = async (selected) => {
    this.loading.startLoading();
    selected.forEach((item) => {
      this.props.deleteProduct(item);
    });
    this.getProduct();
    this.loading.stopLoading();
    return true;
  };
  handleListProduct = (id) => {
    this.setState({ selectedCategory: id });
    this.getProduct({ category_id: id });
  };
  addNewProduct = () => {
    this.props.history.push("/productMenu/create");
  };
  actionColumn = (row = {}, index) => {
    const { classes, t, listProduct = [] } = this.props;
    return (
      <Link to={"/productMenu/edit/" + listProduct[index].id}>
        <Button
          size="small"
          variant="outlined"
          color="primary"
          className={classes.buttonOnRow}
        >
          {t("product_edit")}
        </Button>
      </Link>
    );
  };
  showFilter = (event) => {
    this.FilterList.toggleDrawer(true, event);
  };
  clearFilter = () => {
    let _this = this;
    this.setState(
      {
        discontinued: "",
        on_sale: "",
        stock_status: "",
        enabled: "",
        listFilter: {
          discontinued: "",
          on_sale: "",
          stock_tatus: "",
          enabled: ""
        },
      },
      function () {
        _this.getProduct();
      }
    );
  };
  handleFilter = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  getChildren(selectedId, allItems) {
    return allItems.filter((item) => item.parent_id === selectedId);
  }
  render() {
    const {
      t,
      classes,
      history,
      location,
      listProduct = [],
      total = 0,
    } = this.props;
    let {
      stock_status,
      enabled,
      discontinued,
      on_sale,
      listFilter
    } = this.state;
    return (
      <>
        <Header
          session={t("sidebar_service_and_product")}
          title={t("sidebar_product")}
          button={t("product_add_product")}
          actionButton={this.addNewProduct}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <FilterList
          onRef={(id) => (this.FilterList = id)}
          clearFilter={this.clearFilter}
          getList={this.getProduct}
        >
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("product_enabled")}
              fullWidth
              value={enabled}
              displayEmpty
              onChange={this.handleFilter}
              name="enabled"
              disableUnderline={false}
            >
              {enablebOption.map((e) => {
                return (
                  <MenuItem
                    classes={{ root: classes.textCapitalize }}
                    value={e.value}
                  >
                    {t(e.label)}
                  </MenuItem>
                );
              })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("product_discontinued")}
              fullWidth
              value={discontinued}
              displayEmpty
              onChange={this.handleFilter}
              name="discontinued"
              // margin="normal"
              disableUnderline={false}
            >
              {discontinuedOption.map((e) => {
                return (
                  <MenuItem
                    classes={{ root: classes.textCapitalize }}
                    value={e.value}
                  >
                    {t(e.label)}
                  </MenuItem>
                );
              })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("product_on_sale")}
              fullWidth
              value={on_sale}
              displayEmpty
              onChange={this.handleFilter}
              name="on_sale"
              // margin="normal"
              disableUnderline={false}
            >
              {on_saleOption.map((e) => {
                return (
                  <MenuItem
                    classes={{ root: classes.textCapitalize }}
                    value={e.value}
                  >
                    {t(e.label)}
                  </MenuItem>
                );
              })}
            </InputFormat>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              select
              label={t("product_stock_status")}
              fullWidth
              value={stock_status}
              displayEmpty
              onChange={this.handleFilter}
              name="stock_status"
              // margin="normal"
              disableUnderline={false}
            >
              {stock_statusOption.map((e) => {
                return (
                  <MenuItem
                    classes={{ root: classes.textCapitalize }}
                    value={e.value}
                  >
                    {t(e.label)}
                  </MenuItem>
                );
              })}
            </InputFormat>
          </Grid>
        </FilterList>
        <Grid container spacing={0}>
          <Grid
            item
            xs={12}
            sm={3}
            md={3}
            lg={3}
            style={{ paddingRight: "1rem" }}
          >
            <MultiLevelCategoryList
              handleListItem={this.handleListProduct}
              showManage={true}
              showAll={true}
              history={history}
            />
          </Grid>
          <Grid item xs={12} sm={9} md={9} lg={9}>
            <TableFormat
              onRef={(ref) => (this.mTable = ref)}
              contentDialog={t("product_do_you_want_to_delete_product")}
              onDelete={this.deleteProduct}
              title={t("product_list_product")}
              placeholder={t("product_search")}
              headCells={headCells}
              totalCount={total}
              count={listProduct.length}
              size={"medium"}
              showFilter={true}
              openFilter={(e) => this.showFilter(e)}
              listFilter={listFilter}
              getList={this.getProduct}
              actionColumn={this.actionColumn}
              history={history}
              location={location}
              rows={listProduct.map((row, index) => {
                return {
                  id: row.id,
                  name: row.name,
                  sku: row.sku,
                  stock_quantity: row.stock_quantity,
                  regular_price: <PriceFormat value={row.regular_price} />,
                };
              })}
            />
          </Grid>
        </Grid>
      </>
    );
  }
}

const mapState = (state) => ({
  listProduct: state.product.listProduct,
  total: state.product.total,
});

const mapDispatch = (dispatch) => ({
  getProductCategory: dispatch.productCategory.getProductCategory,
  getProduct: dispatch.product.getProduct,
  deleteProduct: dispatch.product.deleteProduct,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: 0 })(ProductMenu)));
